module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMTUiIHdpZHRoPSIyIiBoZWlnaHQ9IjUiIHJ4PSIxIiBmaWxsPSIjMDA1RUVCIi8+CjxyZWN0IHg9IjQiIHk9IjEyIiB3aWR0aD0iMiIgaGVpZ2h0PSI4IiByeD0iMSIgZmlsbD0iI0Q5RDlEOSIvPgo8cmVjdCB4PSI4IiB5PSI5IiB3aWR0aD0iMiIgaGVpZ2h0PSIxMSIgcng9IjEiIGZpbGw9IiNEOUQ5RDkiLz4KPHJlY3QgeD0iMTIiIHk9IjciIHdpZHRoPSIyIiBoZWlnaHQ9IjEzIiByeD0iMSIgZmlsbD0iI0Q5RDlEOSIvPgo8cmVjdCB4PSIxNiIgeT0iNCIgd2lkdGg9IjIiIGhlaWdodD0iMTYiIHJ4PSIxIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/信号/0-7.svg
// module id = DFBY
// module chunks = 76